import "./styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import idID from "antd/locale/id_ID";
import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ApiError } from "@/api/client";
import { AuthProvider } from "@/auth/AuthProvider";
import { I18nProvider, useI18n } from "@/i18n";
import { router } from "@/routes";
import { lightTheme } from "@/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Client errors (403, 404, validation) will not change on retry.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

function Themed({ children }: { children: ReactNode }) {
  const { locale } = useI18n();
  return (
    <ConfigProvider theme={lightTheme} locale={locale === "id" ? idID : enUS}>
      <AntApp>{children}</AntApp>
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <Themed>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </Themed>
    </I18nProvider>
  </StrictMode>,
);
